<itl-question [title]="node.title" [required]="node.mandatory" [description]="node.description">
  <itl-button
    *ngFor="let button of node.selectables; let i = index"
    [ngStyle]="{
      'border-color': button.borderColor,
      color: button.borderColor,
      'background-color': button.backgroundColor
    }"
    (click)="toggle(i)"
  >
    {{ button.label }}
  </itl-button>
</itl-question>
<!-- Anmerkung wird vorerst ausgebaut, da es nicht genutzt wird -->
<!-- <itl-textarea
  *ngIf="showNote"
  icon="alberta-comment"
  [title]="'audit.node.question.notes' | translate"
  [(value)]="note"
>
</itl-textarea> -->
